/**
 * Asynchronously loads the component for JourneyCardnet
 */

import loadable from '@loadable/component';

export const PaymentSystemsRegulatorLoadable = loadable(
  () => import('./PaymentSystemsRegulator')
);
